var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgNoNotifications = function SvgNoNotifications(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 49,
    viewBox: "0 0 52 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.51,
    cy: 31.846,
    r: 17,
    fill: "#BEBEBE",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.429 14.094c2.143-2.08 5.05-3.248 8.081-3.248 3.031 0 5.938 1.168 8.081 3.248s3.347 4.9 3.347 7.84c0 4.849 1.068 7.803 2.007 9.473.473.84.925 1.38 1.224 1.685.15.154.263.25.322.298.02.017.035.027.042.033.81.548 1.166 1.54.879 2.46-.292.936-1.18 1.576-2.188 1.576H21.796c-1.007 0-1.896-.64-2.188-1.575-.287-.92.07-1.913.88-2.461l.041-.033c.06-.048.172-.144.322-.298.299-.306.751-.844 1.224-1.685.939-1.67 2.007-4.624 2.007-9.472 0-2.941 1.204-5.762 3.347-7.841Zm17.23 18.93c-1.234-2.4-2.292-5.962-2.292-11.09a6.554 6.554 0 0 0-2.008-4.704 6.965 6.965 0 0 0-4.849-1.949c-1.819 0-3.563.701-4.849 1.95a6.554 6.554 0 0 0-2.008 4.704c0 5.127-1.058 8.688-2.292 11.088H44.66Zm-12.932 6.213c1.092-.615 2.49-.254 3.124.805a.75.75 0 0 0 .279.27.78.78 0 0 0 .76 0 .75.75 0 0 0 .279-.27c.634-1.06 2.032-1.42 3.124-.805 1.092.614 1.464 1.971.83 3.03a5.257 5.257 0 0 1-1.951 1.888 5.46 5.46 0 0 1-2.662.691 5.46 5.46 0 0 1-2.662-.69 5.259 5.259 0 0 1-1.951-1.888c-.634-1.06-.262-2.417.83-3.031Z",
    fill: "#DBDBDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.846h5.684v-1.512H2.45l-.014-.028 3.332-4.06V11H.252v1.512h3.024l.014.042L0 16.586v1.26ZM10 13.846h5.684v-1.512H12.45l-.014-.028 3.332-4.06V7h-5.516v1.512h3.024l.014.042L10 12.586v1.26ZM2 6.846h5.684V5.334H4.45l-.014-.028 3.332-4.06V0H2.252v1.512h3.024l.014.042L2 5.586v1.26Z",
    fill: "#DBDBDB"
  })));
};

export default SvgNoNotifications;